import React, { Component } from "react"
import SbEditable from "storyblok-react"
import axios from "axios"
import ImagesService from '../../../utils/images-service'
import Button from "../../Button"


class ContactForm extends Component {
    constructor(props) {
        super(props)
        this.blok = props.blok
        this.state = {
            email: "",
            message: ""
        }

        this.handleMessageChange = this.handleMessageChange.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.send = this.send.bind(this)
    }

    handleMessageChange(event) {
        this.setState({message: event.target.value})
    }

    handleEmailChange(event) {
        this.setState({email: event.target.value})
    }

    async send(event) {
        event.preventDefault()
        if (this.state.email !== "" || this.state.message) {
            try {
                const response = await axios.post("https://api.geraldasamoahstiftung.conducolabs.dev/contact", {
                    email: this.state.email,
                    message: this.state.message
                })
                window.location.replace(response.data.link)
            } catch(error) {
                alert("Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.")
            }
        } else {
            alert("Bitte geben Sie eine gültige E-Mail Adresse und Nachricht ein.")
        }
    }

    render() {
            return (
                <SbEditable content={this.blok}>
                    <div className="hero-block-splitscreen donate">
                        <div className="container">
                            <div className="text">
                                <h1>{this.blok.headline}</h1>
                                <p>{this.blok.teaser}</p>
                                <h4>Ihre E-Mail Adresse</h4>
                                <div className="value-field email">
                                    <input type="email" value={this.state.email} onChange={this.handleEmailChange} className="no-right-padding" />
                                </div>
                                <h4>Ihre Nachricht</h4>
                                <div className="value-field email">
                                    <textarea onChange={this.handleMessageChange} className="no-right-padding">
                                        {this.state.message}
                                    </textarea>
                                </div>
                                <Button type="primary" to="#" action={this.send} label="Nachricht senden" />
                            </div>
                            {this.blok.image.filename !== "" &&
                            <div className="image" style={{backgroundImage: `url(${ ImagesService(this.blok.image.filename, true, { path: '900x1400/smart'}) })`}}>
                                <img src={ImagesService(this.blok.image.filename, true, { path: '450x338/smart'})} srcSet={`${ImagesService(this.blok.image.filename, true, { path: '450x338/smart'})} 1x, ${ImagesService(this.blok.image.filename, true, { path: '900x676/smart'})} 2x`} width="450" height="338" />
                            </div>
                            }
                        </div>
                    </div>
                </SbEditable>
            )
    }
}  
  
export default ContactForm